import { createReducer, on } from '@ngrx/store';
import { FullscreenLayoutAreas } from '@src/assets/css/fullscreen.template.scss';
import { FullscreenActions, SidecarEfffectActions, ThirdSidecarActions } from '@src/suite/common/store/fullscreen/actions/fullscreen.actions';
import { SidecarMenu, SidecarState } from '@src/suite/common/store/fullscreen/models/fullscreen.models';

import { BASE_SIDECAR_INITIAL_STATE } from './fullscreen.reducer';

export const thirdSidecarInitialState: SidecarState = {
    ...BASE_SIDECAR_INITIAL_STATE,
};

export const thirdSidecarReducer = createReducer(
    thirdSidecarInitialState,
    on(
        FullscreenActions.resetState,
        (): SidecarState => ({
            ...thirdSidecarInitialState,
        })
    ),
    on(
        ThirdSidecarActions.selectSidecarMenu,
        (state, { menu }): SidecarState => ({
            ...state,
            selected: menu,
        })
    ),
    on(
        ThirdSidecarActions.selectSidecarAssignment,
        (state, { assignmentGuid }): SidecarState => ({
            ...state,
            selected: SidecarMenu.ASSIGNMENTS,
            selectedAssignmentGuid: assignmentGuid,
        })
    ),
    on(ThirdSidecarActions.setAssignmentViewStates, (state, { viewStates }): SidecarState => {
        return {
            ...state,
            storedAssignmentViewStates: viewStates,
        };
    }),
    on(ThirdSidecarActions.setCurrentAssignmentViewState, (state, { guid }): SidecarState => {
        return {
            ...state,
            currentAssignmentViewStateGuid: guid || null,
        };
    }),
    on(ThirdSidecarActions.setAssignmentListGuids, (state, { assignmentGuids: topicGuids }): SidecarState => {
        return {
            ...state,
            assignmentListGuids: topicGuids,
        };
    }),
    on(ThirdSidecarActions.setTopicViewStates, (state, { viewStates }): SidecarState => {
        return {
            ...state,
            storedTopicViewStates: viewStates,
        };
    }),
    on(ThirdSidecarActions.setCurrentTopicViewState, (state, { guid }): SidecarState => {
        return {
            ...state,
            currentTopicViewStateGuid: guid || null,
        };
    }),
    on(ThirdSidecarActions.setTopicListGuids, (state, { topicGuids }): SidecarState => {
        return {
            ...state,
            topicListGuids: topicGuids,
        };
    }),
    on(ThirdSidecarActions.setRundownViewStates, (state, { viewStates }): SidecarState => {
        return {
            ...state,
            storedRundownViewStates: viewStates,
        };
    }),
    on(ThirdSidecarActions.setCurrentRundownViewState, (state, { guid }): SidecarState => {
        return {
            ...state,
            currentRundownViewStateGuid: guid || null,
        };
    }),
    on(ThirdSidecarActions.setRundownListGuids, (state, { rundownGuids }): SidecarState => {
        return {
            ...state,
            rundownListGuids: rundownGuids,
        };
    }),
    on(
        ThirdSidecarActions.selectSidecarStory,
        (state, { guid }): SidecarState => ({
            ...state,
            selected: SidecarMenu.STORIES,
            selectedStoryGuid: guid,
        })
    ),
    on(ThirdSidecarActions.setStoryViewStates, (state, { viewStates }): SidecarState => {
        return {
            ...state,
            storedStoryViewStates: viewStates,
        };
    }),
    on(ThirdSidecarActions.setCurrentStoryViewState, (state, { guid }): SidecarState => {
        return {
            ...state,
            currentStoryViewStateGuid: guid || null,
        };
    }),
    on(ThirdSidecarActions.setStoryListGuids, (state, { storyGuids }): SidecarState => {
        return {
            ...state,
            storyListGuids: storyGuids,
        };
    }),
    on(ThirdSidecarActions.selectSidecarRundown, (state, { guid }): SidecarState => {
        return {
            ...state,
            selectedRundownGuid: guid,
        };
    }),
    on(ThirdSidecarActions.selectSidecarTopic, (state, { guid }): SidecarState => {
        return {
            ...state,
            selectedTopicGuid: guid,
        };
    }),
    on(ThirdSidecarActions.setCurrentROSelectedStory, (state, { guid }): SidecarState => {
        return {
            ...state,
            currentRundownSelectedStoryGuid: guid,
        };
    }),
    on(ThirdSidecarActions.setCurrentTopicSelectedStory, (state, { guid }): SidecarState => {
        return {
            ...state,
            currentTopicSelectedStoryGuid: guid,
        };
    }),
    on(ThirdSidecarActions.setCurrentTopicSelectedAssignment, (state, { guid }): SidecarState => {
        return {
            ...state,
            currentTopicSelectedAssignmentGuid: guid,
        };
    }),
    on(
        ThirdSidecarActions.setCurrentMosPlugin,
        (state, { mosPluginId: mosId }): SidecarState => ({
            ...state,
            selectedMosPluginID: mosId,
            selectedMosPluginInitialized: false,
        })
    ),
    on(
        ThirdSidecarActions.resetMosState,
        (state): SidecarState => ({
            ...state,
            selectedMosPluginID: null,
            selectedMosPluginInitialized: false,
            selectedMosPluginPendingCommand: null,
        })
    ),
    on(
        ThirdSidecarActions.setAssignmentsListSearchType,
        (state, { searchType }): SidecarState => ({
            ...state,
            selectedAssignmentListSearchType: searchType,
        })
    ),
    on(
        ThirdSidecarActions.setStoriesListSearchType,
        (state, { searchType }): SidecarState => ({
            ...state,
            selectedStoryListSearchType: searchType,
        })
    ),
    on(
        ThirdSidecarActions.setTopicsListSearchType,
        (state, { searchType }): SidecarState => ({
            ...state,
            selectedTopicListSearchType: searchType,
        })
    ),
    on(
        ThirdSidecarActions.setRundownsListSearchType,
        (state, { searchType }): SidecarState => ({
            ...state,
            selectedRundownListSearchType: searchType,
        })
    ),
    on(SidecarEfffectActions.openMosItemInSidecar, (state, { mosPluginId, mosItemCommand, sidecar }): SidecarState => {
        if (sidecar === FullscreenLayoutAreas.SIDECAR_THIRD) {
            return {
                ...state,
                selectedMosPluginID: mosPluginId,
                selectedMosPluginPendingCommand: mosItemCommand,
            };
        }
        return state;
    }),
    on(SidecarEfffectActions.openPendingMosItem, (state, { mosPluginId, sidecar }): SidecarState => {
        if (sidecar === FullscreenLayoutAreas.SIDECAR_THIRD && mosPluginId === state.selectedMosPluginID) {
            return {
                ...state,
                selectedMosPluginPendingCommand: null,
            };
        }
        return state;
    }),
    on(SidecarEfffectActions.setCurrentMosPluginInitialized, (state, { mosPluginId, sidecar }): SidecarState => {
        if (mosPluginId === state.selectedMosPluginID && sidecar === FullscreenLayoutAreas.SIDECAR_THIRD) {
            return {
                ...state,
                selectedMosPluginInitialized: true,
            };
        }
        return state;
    }),
    on(SidecarEfffectActions.setRundownLayout, (state, { roGuid, layout, sidecar }): SidecarState => {
        if (sidecar === FullscreenLayoutAreas.SIDECAR_THIRD) {
            const rundownState = new Map(state.rundownState);
            rundownState.set(roGuid, { selectedLayoutName: layout.name, selectedLayoutType: layout.type });
            return {
                ...state,
                rundownState,
            };
        }
        return state;
    }),
    on(SidecarEfffectActions.openSubStoriesInSidecar, (state, { sidecarType, parentGuid }): SidecarState => {
        if (sidecarType === FullscreenLayoutAreas.SIDECAR_THIRD) {
            return { ...state, subStoriesParentGuid: parentGuid || null };
        }
        return state;
    }),
    on(SidecarEfffectActions.setCurrentSubStories, (state, { sidecarType, parentGuid }): SidecarState => {
        if (sidecarType === FullscreenLayoutAreas.SIDECAR_THIRD) {
            return { ...state, subStoriesParentGuid: parentGuid };
        }
        return state;
    }),
    on(SidecarEfffectActions.clearStoryFromSidecar, (state, { sidecar, excludedMenus }): SidecarState => {
        if (sidecar === FullscreenLayoutAreas.SIDECAR_THIRD) {
            const newState = {
                ...state,
            };
            if (excludedMenus?.length) {
                excludedMenus.forEach(menu => {
                    switch (menu) {
                        case SidecarMenu.STORIES:
                            newState.currentRundownSelectedStoryGuid = null;
                            newState.currentTopicSelectedStoryGuid = null;
                            break;
                        case SidecarMenu.RUNDOWNS:
                            newState.selectedStoryGuid = null;
                            newState.currentTopicSelectedStoryGuid = null;
                            break;
                        case SidecarMenu.TOPICS:
                            newState.selectedStoryGuid = null;
                            newState.currentRundownSelectedStoryGuid = null;
                            break;
                    }
                });
                return newState;
            }
            newState.selectedStoryGuid = null;
            newState.currentRundownSelectedStoryGuid = null;
            newState.currentTopicSelectedStoryGuid = null;
            return newState;
        }
        return state;
    })
);
